import { z } from 'zod';
import { IdSchema, nullableText } from './common.js';
import { SizeClassSchema, SupplyTypeSchema } from './enums.js';
import { MoneySchema } from './money.js';
/** Savat qatori. Narx joriy katalogdan — snapshot faqat buyurtmada olinadi. */
export const CartItemResponseSchema = z.object({
    id: IdSchema,
    productId: IdSchema,
    sku: z.string(),
    nameUz: z.string(),
    nameRu: nullableText(200),
    brandName: z.string(),
    imageUrl: z.string().nullable(),
    categoryIconKey: nullableText(32),
    unitPrice: MoneySchema,
    qty: z.number().int().positive(),
    lineTotal: MoneySchema,
    supplyType: SupplyTypeSchema,
    leadTimeDays: z.number().int().nonnegative(),
    sizeClass: SizeClassSchema,
    /** Tanlangan hududda darhol berish mumkinmi. */
    availableNow: z.boolean(),
    /**
     * Eng ko'pi bilan nechta buyurtma qilish mumkin: `IN_STOCK` — mavjud qoldiq
     * (0 bo'lishi mumkin — tugagan), `PRE_ORDER` — `null` (qoldiq yuritilmaydi,
     * faqat umumiy 999 chegara). Klient stepper chegarasini shundan oladi.
     */
    maxQty: z.number().int().nonnegative().nullable(),
});
/**
 * Savat javobi. `hasMixedSupply` rost bo'lsa checkout'da bo'lish savoli
 * ko'rsatiladi (docs/02-MAHSULOT.md).
 */
export const CartResponseSchema = z.object({
    id: IdSchema,
    items: z.array(CartItemResponseSchema),
    itemsTotal: MoneySchema,
    itemCount: z.number().int().nonnegative(),
    hasMixedSupply: z.boolean(),
    maxLeadTimeDays: z.number().int().nonnegative(),
});
export const AddToCartSchema = z
    .object({
    productId: IdSchema,
    qty: z.number().int().min(1).max(999).default(1),
})
    .strict();
/** `qty: 0` qatorni o'chiradi — alohida endpoint kerak emas. */
export const UpdateCartItemSchema = z.object({ qty: z.number().int().min(0).max(999) }).strict();
//# sourceMappingURL=cart.js.map